export const movies = [
  {
    id: "mv-001",
    title: "逆光飞行",
    type: "movie",
    genres: ["剧情", "励志"],
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    director: "陈亦航",
    actors: ["林知远", "苏晴", "周牧"],
    duration: "128分钟",
    updatedAt: "2025-09-28",
    popularity: 9820,
    hot: true,
    badge: "独家",
    description:
      "一位因伤退役的滑翔伞运动员回到故乡小城，面对质疑与生活的重压，他决定带领一群被忽视的年轻人重新挑战蓝天。影片以温暖细腻的镜头语言讲述关于失败、坚持与自我和解的故事，在一次次起飞与坠落之间，找回被现实掩埋的勇气。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20a%20lone%20paraglider%20silhouette%20against%20a%20warm%20orange%20sunset%20sky%20over%20distant%20mountains%2C%20dramatic%20color%20grading%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20editorial%20composition%2C%20no%20text&width=400&height=600&seq=mv001-poster&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20landscape%20of%20a%20lone%20paraglider%20gliding%20above%20misty%20mountains%20at%20golden%20sunset%2C%20warm%20orange%20and%20amber%20tones%2C%20atmospheric%20haze%2C%20dramatic%20lighting%2C%20film%20still%20quality%2C%20no%20text&width=1600&height=900&seq=mv001-hero&orientation=landscape",
  },
  {
    id: "mv-002",
    title: "夜幕追凶",
    type: "movie",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    director: "高远",
    actors: ["沈默", "何嘉", "许南风"],
    duration: "116分钟",
    updatedAt: "2025-09-22",
    popularity: 8760,
    hot: true,
    badge: "热映",
    description:
      "连环失踪案在城市夜幕下悄然发生，一名被停职的老刑警与初出茅庐的女法医被迫联手。随着线索层层揭开，真相指向一段被刻意掩埋的往事。影片节奏紧凑、氛围冷峻，在推理与人性之间反复拉扯，让观众始终无法移开视线。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%20style%2C%20a%20moody%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%20and%20a%20solitary%20figure%20in%20a%20coat%2C%20dark%20teal%20and%20amber%20accents%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20editorial%20composition%2C%20no%20text&width=400&height=600&seq=mv002-poster&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20cityscape%20in%20heavy%20rain%20with%20glowing%20amber%20streetlamps%20and%20wet%20reflective%20asphalt%2C%20moody%20suspenseful%20atmosphere%2C%20deep%20shadows%2C%20film%20noir%20still%2C%20no%20text&width=1600&height=900&seq=mv002-hero&orientation=landscape",
  },
  {
    id: "mv-003",
    title: "时光信箱",
    type: "movie",
    genres: ["爱情", "奇幻"],
    region: "中国台湾",
    year: 2024,
    rating: 8.1,
    director: "吴念真",
    actors: ["程予希", "江辰", "林宜"],
    duration: "104分钟",
    updatedAt: "2025-08-30",
    popularity: 6540,
    hot: false,
    description:
      "一间即将拆迁的老邮局里，藏着一个能把信件寄往过去的绿色信箱。实习邮差在整理旧信时，意外与二十年前的一段爱情产生交集。影片用轻柔的节奏与治愈的画面，讲述跨越时间的思念，以及那些未曾说出口的告白。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20style%2C%20a%20vintage%20green%20mailbox%20on%20a%20quiet%20sunlit%20street%20with%20floating%20letters%20in%20the%20air%2C%20soft%20peach%20and%20sage%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20editorial%20composition%2C%20no%20text&width=400&height=600&seq=mv003-poster&orientation=portrait",
  },
  {
    id: "mv-004",
    title: "星际回响",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.9,
    director: "Daniel Morse",
    actors: ["Ethan Blake", "Mia Coleman", "Oscar Reid"],
    duration: "142分钟",
    updatedAt: "2025-10-02",
    popularity: 11250,
    hot: true,
    badge: "高分",
    description:
      "人类第一支深空探索舰队在抵达陌生星域后失去联系，唯有微弱的一段回响持续传回地球。为了解开其中的信息，一支临时组建的救援小队踏上未知旅程。影片以宏大的宇宙视觉与克制的叙事，探讨孤独、希望与文明的延续。",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20movie%20poster%20style%2C%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20ringed%20planet%20with%20warm%20amber%20nebula%20clouds%2C%20dramatic%20contrast%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20editorial%20composition%2C%20no%20text&width=400&height=600&seq=mv004-poster&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20deep%20space%20scene%20with%20a%20massive%20warm%20amber%20planet%20and%20glowing%20nebula%20dust%2C%20distant%20spacecraft%20silhouette%2C%20epic%20sense%20of%20scale%2C%20film%20still%20quality%2C%20no%20text&width=1600&height=900&seq=mv004-hero&orientation=landscape",
  },
  {
    id: "mv-005",
    title: "山那边的夏天",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2024,
    rating: 8.3,
    director: "周明川",
    actors: ["赵天成", "李婉", "小满"],
    duration: "118分钟",
    updatedAt: "2025-07-18",
    popularity: 5210,
    hot: false,
    description:
      "城市里长大的少年被送回山村老家度过暑假，与沉默寡言的祖父从陌生到彼此理解。一个关于稻田、蝉鸣与老屋的夏天，悄然改变了两个人。影片用质朴的镜头记录乡村时光，讲述代际之间的温情与告别。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20movie%20poster%20style%2C%20a%20boy%20and%20an%20elderly%20man%20walking%20through%20golden%20rice%20fields%20under%20summer%20sunlight%2C%20soft%20amber%20and%20green%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20editorial%20composition%2C%20no%20text&width=400&height=600&seq=mv005-poster&orientation=portrait",
  },
  {
    id: "mv-006",
    title: "孤岛生还",
    type: "movie",
    genres: ["冒险", "灾难"],
    region: "英国",
    year: 2025,
    rating: 7.9,
    director: "James Holland",
    actors: ["Noah Bennett", "Grace Turner"],
    duration: "125分钟",
    updatedAt: "2025-09-12",
    popularity: 6120,
    hot: false,
    description:
      "一架客机在风暴中失事，仅少数幸存者漂流至一座无人荒岛。面对有限的食物、恶劣的天气与彼此的猜忌，他们必须在绝望中重建秩序。影片以强烈的生存张力与真实感，展现人类在极限处境下的选择与羁绊。",
    poster:
      "https://readdy.ai/api/search-image?query=Survival%20adventure%20movie%20poster%20style%2C%20a%20solitary%20figure%20standing%20on%20a%20rocky%20shore%20facing%20turbulent%20stormy%20ocean%20waves%2C%20moody%20grey%20blue%20and%20warm%20highlight%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mv006-poster&orientation=portrait",
  },
  {
    id: "tv-001",
    title: "长夜灯火",
    type: "tv",
    genres: ["都市", "情感"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    director: "宋佳宁",
    actors: ["顾念", "陆时", "方晴"],
    duration: "45分钟/集 全32集",
    updatedAt: "2025-10-06",
    popularity: 10430,
    hot: true,
    badge: "热播",
    description:
      "深夜便利店的三位店员，各自背负着不为人知的心事。一盏彻夜不熄的灯火，让无数深夜归人的故事在此交汇。剧集以单元式的温暖叙事，勾勒都市生活中的孤独、善意与相互照亮，被誉为年度治愈之作。",
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20TV%20series%20poster%20style%2C%20a%20warm%20glowing%20convenience%20store%20window%20at%20night%20with%20a%20lonely%20silhouette%2C%20cozy%20amber%20light%20against%20deep%20blue%20city%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tv001-poster&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20city%20street%20with%20a%20warm%20glowing%20shopfront%20and%20gentle%20rain%2C%20cozy%20amber%20lighting%20against%20cool%20blue%20tones%2C%20urban%20atmosphere%2C%20film%20still%20quality%2C%20no%20text&width=1600&height=900&seq=tv001-hero&orientation=landscape",
  },
  {
    id: "tv-002",
    title: "锦衣少年行",
    type: "tv",
    genres: ["古装", "武侠"],
    region: "中国大陆",
    year: 2024,
    rating: 8.2,
    director: "韩子墨",
    actors: ["裴昱", "柳如烟", "萧然"],
    duration: "40分钟/集 全40集",
    updatedAt: "2025-06-15",
    popularity: 7890,
    hot: false,
    description:
      "少年锦衣卫初入京城，卷入一桩震动朝野的奇案。在追查真相的路上，他结识了亦敌亦友的江湖侠士，也逐渐看清权力背后的暗流。剧集融合探案、武侠与成长，画面唯美，打斗设计行云流水。",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20period%20drama%20poster%20style%2C%20a%20young%20swordsman%20in%20elegant%20traditional%20robes%20with%20a%20flowing%20cape%20amid%20misty%20bamboo%2C%20warm%20amber%20and%20jade%20green%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tv002-poster&orientation=portrait",
  },
  {
    id: "tv-003",
    title: "白色迷局",
    type: "tv",
    genres: ["悬疑", "医疗"],
    region: "韩国",
    year: 2025,
    rating: 8.7,
    director: "Kim Do-hyun",
    actors: ["Seo Jin", "Han Ryeo", "Lee Min"],
    duration: "60分钟/集 全16集",
    updatedAt: "2025-09-30",
    popularity: 9010,
    hot: true,
    description:
      "一家顶级医院接连发生离奇医疗事故，天才外科医生在抢救生命的同时，发现自己正被卷入一场精心策划的阴谋。剧集将手术室的紧张感与悬疑推理巧妙结合，反转不断，令人欲罢不能。",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20suspense%20drama%20poster%20style%2C%20a%20surgeon%20in%20a%20dim%20operating%20room%20with%20dramatic%20teal%20and%20amber%20lighting%2C%20clinical%20sterile%20atmosphere%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tv003-poster&orientation=portrait",
  },
  {
    id: "tv-004",
    title: "我们的八零年代",
    type: "tv",
    genres: ["年代", "家庭"],
    region: "中国大陆",
    year: 2024,
    rating: 8.5,
    director: "刘建国",
    actors: ["王海", "张莉", "刘星"],
    duration: "45分钟/集 全36集",
    updatedAt: "2025-05-20",
    popularity: 7230,
    hot: false,
    description:
      "一条老巷子，三家普通人，从粮票到第一批下海经商，见证了时代浪潮中的悲欢离合。剧集以细腻的群像刻画和充满烟火气的细节，唤起一代人的集体记忆，笑中带泪，回味悠长。",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20period%20family%20drama%20poster%20style%2C%20a%20warm%201980s%20Chinese%20alleyway%20with%20old%20bicycles%20and%20laundry%2C%20faded%20amber%20and%20muted%20green%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tv004-poster&orientation=portrait",
  },
  {
    id: "tv-005",
    title: "星海之约",
    type: "tv",
    genres: ["科幻", "爱情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    director: "林澈",
    actors: ["江遥", "沈星", "罗宇"],
    duration: "50分钟/集 全24集",
    updatedAt: "2025-10-09",
    popularity: 6890,
    hot: false,
    description:
      "地面观测站的天文学者与远在深空飞船上的宇航员，仅靠延迟数十分钟的信号保持联系。当飞船遭遇故障，跨越亿万公里的牵挂成为他们坚持下去的唯一理由。一部浪漫而克制的科幻爱情剧。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20drama%20poster%20style%2C%20two%20silhouetted%20figures%20connected%20by%20a%20glowing%20line%20of%20light%20between%20earth%20and%20stars%2C%20warm%20amber%20and%20deep%20indigo%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tv005-poster&orientation=portrait",
  },
  {
    id: "va-001",
    title: "欢乐大玩家",
    type: "variety",
    genres: ["游戏", "竞技"],
    region: "中国大陆",
    year: 2025,
    rating: 8.1,
    director: "综艺制作组",
    actors: ["常驻嘉宾：沈睿", "程小雨", "阿凯", "何一诺"],
    duration: "90分钟/期 更新至第18期",
    updatedAt: "2025-10-11",
    popularity: 9540,
    hot: true,
    badge: "热播",
    description:
      "六位风格迥异的常驻嘉宾组成固定战队，在城市实景中完成脑力与体力的双重挑战。节目节奏明快、笑点密集，同时融入团队协作与临场应变，是周末全家观看的解压首选。",
    poster:
      "https://readdy.ai/api/search-image?query=Vibrant%20game%20show%20poster%20style%2C%20colorful%20playful%20geometric%20shapes%20and%20confetti%20with%20energetic%20movement%2C%20warm%20orange%20and%20coral%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=va001-poster&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20vibrant%20TV%20studio%20game%20show%20set%20with%20colorful%20lights%20and%20energetic%20atmosphere%2C%20warm%20orange%20and%20coral%20stage%20lighting%2C%20dynamic%20sense%20of%20fun%2C%20no%20text&width=1600&height=900&seq=va001-hero&orientation=landscape",
  },
  {
    id: "va-002",
    title: "味蕾旅途",
    type: "variety",
    genres: ["美食", "纪实"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    director: "纪录片团队",
    actors: ["主持人：周然"],
    duration: "45分钟/期 全12期",
    updatedAt: "2025-04-28",
    popularity: 8120,
    hot: false,
    description:
      "主持人背着简单的行囊走访各地小城，寻找藏在街巷里的地道风味与坚守多年的手艺人。节目不追求戏剧冲突，只安静记录一餐一饭背后的故事，温暖而治愈。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20food%20documentary%20poster%20style%2C%20steaming%20rustic%20dishes%20on%20a%20wooden%20table%20with%20chopsticks%20and%20fresh%20ingredients%2C%20rich%20amber%20and%20earthy%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=va002-poster&orientation=portrait",
  },
  {
    id: "va-003",
    title: "声动未来",
    type: "variety",
    genres: ["音乐", "选秀"],
    region: "中国大陆",
    year: 2025,
    rating: 8.3,
    director: "综艺制作组",
    actors: ["导师：苏黎", "顾言", "陈默"],
    duration: "100分钟/期 更新至第10期",
    updatedAt: "2025-10-08",
    popularity: 8790,
    hot: false,
    description:
      "来自各行各业的素人歌手登上舞台，用声音讲述自己的故事。节目既有专业导师的真诚点评，也有令人惊艳的现场舞台，见证普通人追逐音乐梦想的每一步。",
    poster:
      "https://readdy.ai/api/search-image?query=Music%20talent%20show%20poster%20style%2C%20a%20singer%20silhouette%20under%20a%20warm%20spotlight%20with%20glowing%20soundwave%20lines%2C%20amber%20and%20violet%20stage%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=va003-poster&orientation=portrait",
  },
  {
    id: "va-004",
    title: "奇妙探险家",
    type: "variety",
    genres: ["户外", "真人秀"],
    region: "中国大陆",
    year: 2025,
    rating: 7.9,
    director: "综艺制作组",
    actors: ["常驻嘉宾：林野", "夏至", "高远"],
    duration: "85分钟/期 更新至第14期",
    updatedAt: "2025-10-04",
    popularity: 7020,
    hot: false,
    description:
      "嘉宾们深入无人区、原始森林与戈壁荒漠，在没有剧本的前提下完成一次次探险任务。节目展现自然之美与人类渺小，也记录团队在极端环境中的真实反应与相互扶持。",
    poster:
      "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20poster%20style%2C%20a%20small%20group%20of%20hikers%20on%20a%20vast%20golden%20desert%20dune%20under%20a%20huge%20sky%2C%20warm%20sand%20and%20amber%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=va004-poster&orientation=portrait",
  },
  {
    id: "va-005",
    title: "喜剧之夜",
    type: "variety",
    genres: ["喜剧", "语言"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    director: "综艺制作组",
    actors: ["常驻卡司：大鹏", "阿雅", "老张"],
    duration: "75分钟/期 全16期",
    updatedAt: "2025-03-16",
    popularity: 7640,
    hot: false,
    description:
      "国内顶尖喜剧团队同台竞技，围绕生活热点即兴创作。节目既有扎实的文本功底，也有临场的爆笑互动，用幽默化解生活的疲惫，是一档名副其实的快乐制造机。",
    poster:
      "https://readdy.ai/api/search-image?query=Comedy%20variety%20show%20poster%20style%2C%20a%20vintage%20theater%20stage%20with%20warm%20spotlights%20and%20a%20microphone%2C%20playful%20orange%20and%20cream%20tones%2C%20minimal%20clean%20background%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=va005-poster&orientation=portrait",
  },
];

export const news = [
  { id: "n-01", title: "《逆光飞行》口碑持续走高，登顶本周热播榜第一", date: "2025-10-12", category: "热播" },
  { id: "n-02", title: "科幻巨制《星际回响》宣布加映，主创团队回应续集计划", date: "2025-10-11", category: "资讯" },
  { id: "n-03", title: "年度治愈剧《长夜灯火》迎来收官，观众评分稳定 8.6", date: "2025-10-10", category: "剧集" },
  { id: "n-04", title: "《声动未来》第十期迎来最强舞台，素人歌手惊艳全场", date: "2025-10-09", category: "综艺" },
  { id: "n-05", title: "悬疑剧《白色迷局》官宣第六集反转，登上热搜榜首", date: "2025-10-08", category: "剧集" },
  { id: "n-06", title: "《锦衣少年行》第二季正式立项，原班人马有望回归", date: "2025-10-07", category: "资讯" },
];